module.exports = require('./helpers/bundle-url').getBundleURL('fD1a9') + "logo.c51670a8.svg";